/**
 * Ball Physics Class
 */
window.Ball = class Ball {
  constructor(startingPos, radius, damping) {
    this.startingPos = startingPos.copy();
    this.pos = startingPos.copy();
    this.vel = createVector(0, 0);
    this.radius = radius;
    this.damping = damping;
  }

  update(gravity, figure, textElements, canvasEventsActive) {
    if (interaction.isDraggingBall) {
      this.pos.set(mouseX, mouseY);
      this.vel.set(0, 0);
      return;
    }

    // Apply forces
    this.vel.add(gravity);
    this.pos.add(this.vel);

    // Check boundary collisions
    this._handleBoundaries();

    // Check collision with the foot
    const footVel = p5.Vector.sub(figure.anklePos, figure.prevAnklePos);
    const collisionInfo = this._checkFootCollision(figure);
    if (collisionInfo.collided) {
      this._handleKick(collisionInfo, footVel);
    }

    // Check collision with the hitting field
    if (this.pos.y <= HITTINGHEIGHTTRESHOLD) {
      lastHit = 0;
    }

    // Check collision with Canvas Events (text hitboxes)
    if (canvasEventsActive) {
      this._checkTextCollisions(textElements);
    }
  }

  draw() {
    stroke(0);
    strokeWeight(2);
    fill(255);
    ellipse(this.pos.x, this.pos.y, this.radius * 2, this.radius * 2);
  }

  reset() {
    this.pos.set(this.startingPos);
    this.vel.set(0, 0);
  }

  _handleBoundaries() {
    // Ground collision
    if (this.pos.y + this.radius > groundY) {
      this.pos.y = groundY - this.radius;
      this.vel.y *= -this.damping;
      this.vel.x *= 0.98; // Friction
    }
    // Side wall reset
    if (this.pos.x > rightbbcoord || this.pos.x < leftbbcoord) {
      this.reset();
    }
  }

  _checkFootCollision(figure) {
    const foot = figure.config.leg.foot;
    const footCenterFromPivot = createVector(foot.length / 2 - 10, 0);
    const rotatedOffset = footCenterFromPivot.copy().rotate(figure.angles.foot);
    const footCenter = p5.Vector.add(figure.anklePos, rotatedOffset);
    
    const v = p5.Vector.sub(this.pos, footCenter);
    const vRotated = v.copy().rotate(-figure.angles.foot);
    
    const halfW = foot.length / 2;
    const halfH = foot.width / 2;
    const closestX = constrain(vRotated.x, -halfW, halfW);
    const closestY = constrain(vRotated.y, -halfH, halfH);
    
    const distance = dist(vRotated.x, vRotated.y, closestX, closestY);
    
    if (distance < this.radius) {
      const normalInLocal = p5.Vector.sub(vRotated, createVector(closestX, closestY));
      return {
        collided: true,
        normal: normalInLocal.normalize().rotate(figure.angles.foot),
        penetration: this.radius - distance
      };
    }
    return { collided: false };
  }

  _handleKick(collisionInfo, footVel) {
    // 1. Resolve penetration (push the ball out of the foot)
    const pushback = collisionInfo.normal.copy().mult(collisionInfo.penetration + 2);
    this.pos.add(pushback);

    // 2. Calculate bounce velocity (reflection)
    const dotProduct = this.vel.dot(collisionInfo.normal);
    const bounce = collisionInfo.normal.copy().mult(2 * dotProduct);
    const bounceVel = p5.Vector.sub(this.vel, bounce).mult(this.damping);

    // 3. Add velocity from the foot's movement (the "kick")
    // We use a higher multiplier and add it to the bounce for maximum impact
    const kickVel = footVel.copy().mult(2.5);
    
    // 4. Combine and set final velocity
    this.vel.set(bounceVel).add(kickVel).limit(15);
  }

  _checkTextCollisions(textElements) {
    for (let item of textElements) {
      if (this.pos.x >= item.x && 
          this.pos.x <= item.x + item.w && 
          this.pos.y >= item.y && 
          this.pos.y <= item.y + item.h) {
        
        if (typeof window.onCanvasEventHit === 'function') {
          window.onCanvasEventHit(item.event);
        }
        break; // Stop checking after one hit
      }
    }
  }
}
